import type React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { syncIntegrationsThunk } from "../../store/effects/integrationSync";

export const withIntegrationsSyncCall = <P extends {}>(Component: React.ComponentType<P>) => {
    return function IntegrationsSyncCall(props: P) {
        const dispatch = useDispatch();

        useEffect(() => {
            dispatch(syncIntegrationsThunk());
        }, []);

        return <Component {...props} />;
    };
};
